/* global process, communityLat, communityLong */

// GET with Promise
import get from '../../plugins/get';

import getDistance from '../../plugins/get-distance';

export default () => {

  if ($('.community-landing-nearby').length) {

    // HTTP request with Promise to get Communities
    get(process.env.COMMUNITIES_ENDPOINT).then(JSON.parse).then((communities) => {

      let nearbyCommunities = [];

      // Loop through markers to check if they're inside of the radius
      communities.map((el) => {

        // Get distance between the marker and the searched location
        const distanceBetween = getDistance(el.latitude, el.longitude, communityLat, communityLong);

        el.distanceBetween = distanceBetween.toFixed(1);

        if (el.distanceBetween > 0) {
          nearbyCommunities.push(el);
        }

      });

      nearbyCommunities = nearbyCommunities.sort((a, b) => {
        return a.distanceBetween - b.distanceBetween;
      }).slice(0, 2);

      nearbyCommunities.map((community) => {

        const types = community.types.join(', ');

        const nearbyCommunityItem = `
          <a class="community-landing-nearby-item" href="${community.url}">
            <div class="community-landing-nearby-item-distance">
              <div class="community-landing-nearby-item-distance-number">${community.distanceBetween}</div>
              <div class="community-landing-nearby-item-distance-text">
                <div class="community-landing-nearby-item-distance-text-line">miles</div>
                <div class="community-landing-nearby-item-distance-text-line">away</div>
              </div>
            </div>
            <div class="community-landing-nearby-item-image">
              <div class="community-landing-nearby-item-image-inner" style="background-image: url('${community.nearbyImage}')"></div>
            </div>
            <div class="community-landing-nearby-item-content">
              <h4 class="community-landing-nearby-item-title">${community.title}</h4>
              <div class="community-landing-nearby-item-address">${community.city}, ${community.state}</div>
              <div class="community-landing-nearby-item-types">${types}</div>
            </div>
          </a>
        `;

        $('.community-landing-nearby-items').append(nearbyCommunityItem);

      });

    });

  }

};
